<template>
  <div class="f">
    <!-- This one is a dummy selector in the event that there is an attached Slack user and they're importing it's data -->
    <donut-selector-single-static
      v-if="slackUser && importFromSlack"
      :model-value="slackUser.time_zone_info"
      :options="[]"
      class="w-x36"
      :disabled="true"
    />
    <!-- This one is real: either they aren't importing data from Slack, don't have an attached Slack user, or both -->
    <donut-selector-single-static
      v-else
      v-model="timeZone"
      :options="state.onboardingManualEnrollment.timeZones"
      :allow-search="true"
      class="w-x36"
    />
    <div class="f-jc f-ac m-lx2">
      <donut-input-checkbox v-model="importFromSlack" label="Import from Slack" />
      <i v-tooltip="importTimeZoneTooltip" class="mi gray md-18 m-l">info</i>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, getters, dispatch } = useStore();

  const props = defineProps({ session: { type: Object, required: true } });

  const slackUser = computed(() => props.session.memberships.find(m => m.role.primary)?.user);

  // Import From Slack
  const importFromSlack = computed({
    get() { return props.session.importTimeZoneFromSlack; },
    set(value) {
      dispatch('onboardingManualEnrollment/updateSession', { id: props.session.id, key: 'importTimeZoneFromSlack', value });
    },
  });

  // Time Zone
  const timeZone = computed({
    get() { return props.session.timeZone; },
    set(value) {
      dispatch('onboardingManualEnrollment/updateSession', { id: props.session.id, key: 'timeZone', value });
    },
  });

  // Explainer Copy
  const importTimeZoneTooltip = computed(() => {
    const roleName = state.onboardingManualEnrollment.flowType.primaryRole;
    if (importFromSlack.value) {
      if (slackUser.value) {
        return `This ${roleName}'s time zone has been imported automatically from Slack. To override, uncheck this box and select a time zone manually.`;
      }
      // No attached Slack user yet, so the session may not have a time zone selected — guard the label read.
      return timeZone.value
        ? `This ${roleName}'s time zone is set to ${timeZone.value.label}. When their Slack profile is added or becomes active, new time zone data will sync automatically.`
        : `This ${roleName}'s time zone hasn't been set yet. When their Slack profile is added or becomes active, new time zone data will sync automatically.`;
    }
      return `Manually select this ${roleName}'s time zone from the drop-down to the left. You may check this box at any time to sync new time zone data from Slack.`;
  });
</script>
